import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Col, Icon, Row, RSelect } from "../../components/Component";
import { GET, POST } from "../../helper/api";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { renderPageStyle } from "../../utils/Utils";




const DailyReport = () => {
  const historyDom = useHistory();
  const [smOption, setSmOption] = useState(false);
  const printRef = useRef();
  const [history, setHistory] = useState(null);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [timeNow, setTimeNow] = useState();
  const [warehouseOptions, setWarehouseOptions] = useState([]);

  const [filter, setFilter] = useState({
    date: searchParams.get("date") || moment().format("YYYY-MM-DD"),
    warehouseId: searchParams.get("warehouseId") || undefined,
  });

  useEffect(() => {
    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          } || [])
        )
      );
    });
  }, [])

  useEffect(() => {
    const newParams = new URLSearchParams({
      date: filter.date,
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
    });
    historyDom.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });

    GET(
      `/report/history`,
      {
        date: filter.date,
        ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
      },
      true
    ).then((resp) => {
      const { data } = resp;
      setHistory(data);
    });
  }, [filter, timeNow]);

  const exportExcel = () => {
    const params = new URLSearchParams({
      date: filter.date,
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
      token: getToken(),
    });
    const url = `${process.env.REACT_APP_API_URL}/api/v1/report/history-excel?${params.toString()}`;
    window.open(url, "_blank");
  };

  const updateStatement = () => {
    POST(
      `/sumary-statement/calculated-previous-month`, {}, {}, true
    ).then(() => {
      toast.success('Cập nhật thành công')
      setTimeNow(moment().valueOf())
    });
  }
  return (
    <React.Fragment>
      <Head title="Báo cáo"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div className="toggle-expand-content" style={{ display: smOption ? "block" : "none" }}>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-group">
                        <div className="form-control-wrap">
                          <input placeholder="Lọc theo ngày" onChange={(e) => {
                            setFilter({
                              ...filter,
                              date: moment(e.target.value).format("YYYY-MM-DD")
                            });
                          }} value={filter.date} type="date" className="form-control" />
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="form-group">
                        <div className="form-control-wrap">
                          <RSelect
                            isClearable
                            placeholder={"Lọc theo kho"}
                            options={warehouseOptions}
                            value={warehouseOptions.find((c) => c.value === filter.warehouseId) || null}
                            onChange={(val) => {
                              setFilter({
                                ...filter,
                                warehouseId: val?.value || undefined,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="d-inline-block mr-3">
                        <ReactToPrint
                          trigger={() => <Button>In</Button>}
                          content={() => printRef.current}
                        />
                        <Button onClick={exportExcel} className="ml-3">
                          Xuất excel
                        </Button>
                        <Button onClick={updateStatement} className="ml-3">
                          Cập nhật lại đầu kỳ
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <div id="DataTables_Table_1_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer bg-white">
            <div className="row justify-between g-2">
              <div className="col-8 col-sm-6 text-start"></div>
              <div className="col-5 col-sm-6 text-end">
                <div className="datatable-filter">
                  <div className="d-flex justify-content-end g-2">
                    <div className="dataTables_length" id="DataTables_Table_1_length"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="my-3">

              <Row>
                {history ? (
                  <Col md={12}>
                    <div ref={printRef}>
                      <style>{renderPageStyle({
                        scale: 70,
                        margin: 15,
                        fontSize: 15,
                      })}</style>
                      <h5 className="text-center">Báo cáo thu chi ngày {moment(filter.date).format('DD-MM-YYYY')} </h5>
                      <table className="table-bordered w-100 table table-responsive" >
                        <tbody>
                          <tr style={{ backgroundColor: "#91d14f" }}>

                            <td style={{ textAlign: "center" }} colSpan={8}>
                              QUẢN LÝ XUÁT NHẬP VÀ CHI PHÍ
                            </td>
                          </tr>

                          <tr style={{ backgroundColor: "#93ffc2" }}>
                            <th>Hạng Mục</th>
                            <th>Số Lượng(kg)</th>
                            <th>Đơn Giá(vnđ)</th>
                            <th>Thành Tiền(vnđ)</th>
                            <th>Hạng Mục</th>
                            <th>Số Lượng(kg)</th>
                            <th>Đơn Giá(vnđ)</th>
                            <th>Thành Tiền(vnđ)</th>
                          </tr>
                          <tr style={{ backgroundColor: "#feff98" }}>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              CHI TRONG NGÀY
                            </td>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              LUỸ KẾ CHI TỚI THỜI ĐIỂM HIỆN TẠI
                            </td>
                          </tr>

                          {history.billByDayObj?.data.map((c, i) => {
                            const m = history.billByAllObj?.data[i];
                            return (
                              <tr key={i}>
                                <td>{c.outName}</td>
                                <td>
                                  <NumericFormat value={c.outWeight || 0} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                                </td>
                                <td>
                                  <NumericFormat value={c.outUnit || 0} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                                </td>
                                <td>
                                  <NumericFormat value={c.outAmount || 0} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                                </td>

                                <td>{m.outName}</td>
                                <td>
                                  <NumericFormat value={m.outWeight || 0} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                                </td>
                                <td>
                                  <NumericFormat value={m.outUnit || 0} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                                </td>
                                <td>
                                  <NumericFormat value={m.outAmount || 0} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                                </td>
                              </tr>
                            );
                          })}
                          <tr style={{ backgroundColor: "#ecf0de" }}>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              Tổng Chi
                            </td>
                            <td>
                              {" "}
                              <NumericFormat value={history.billByDayObj.sumOut || 0} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                            </td>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              Luỹ kế chi tới thời điểm hiện tại
                            </td>
                            <td>
                              {" "}
                              <NumericFormat value={history.billByAllObj.sumOut || 0} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                            </td>

                          </tr>
                          <tr style={{ backgroundColor: "#feff98" }}>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              THU TRONG NGÀY
                            </td>
                            <td style={{ textAlign: "center" }} colSpan={4}>
                              LUỸ KẾ THU TỚI THỜI ĐIỂM HIỆN TẠI
                            </td>
                          </tr>

                          {history.billByDayObj?.data.map((c, i) => {
                            const m = history.billByAllObj?.data[i];
                            return (
                              <tr key={i}>
                                <td>{c.inName}</td>
                                <td>
                                  <NumericFormat value={c.inWeight || 0} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                                </td>
                                <td>
                                  <NumericFormat value={c.inUnit || 0} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                                </td>
                                <td>
                                  <NumericFormat value={c.inAmount || 0} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                                </td>

                                <td>{m.inName}</td>
                                <td>
                                  <NumericFormat value={m.inWeight || 0} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                                </td>
                                <td>
                                  <NumericFormat value={m.inUnit || 0} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                                </td>
                                <td>
                                  <NumericFormat value={m.inAmount || 0} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                                </td>
                              </tr>
                            );
                          })}
                          <tr style={{ backgroundColor: "#ecf0de" }}>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              Tổng Thu
                            </td>
                            <td>
                              <NumericFormat value={history.billByDayObj.sumIn || 0} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                            </td>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              Luỹ kế thu tới thời điểm hiện tại
                            </td>
                            <td>
                              <NumericFormat value={history.billByAllObj.sumIn || 0} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                            </td>
                          </tr>

                          <tr style={{ backgroundColor: "#e4dfed" }}>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              CÒN LẠI TRONG NGÀY
                            </td>
                            <td>
                              <NumericFormat value={history.billByDayObj.revenue} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                            </td>
                            <td style={{ textAlign: "right" }} colSpan={3}>
                              CÒN LẠI TỚI THỜI ĐIỂM HIỆN TẠI
                            </td>
                            <td>
                              <NumericFormat value={history.billByAllObj.revenue} thousandsGroupStyle="thousand" thousandSeparator="," decimalScale={0} displayType="text" />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                ) : (
                  ""
                )}
              </Row>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default DailyReport;
